/*
 * Copyright (c) 2023. Collabro Limited
 */

import React, { useEffect, useState } from "react";
import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { SortProps } from "./SortScreen";

export interface SortToggleProps {
  name: string;
  sortValue: SortProps[];
  onChange: any;
}

const SortToggle = (props: SortToggleProps) => {
  const handleChange = (e: any, newSortValue: "asc" | "desc") => {
    props.onChange(props.name, newSortValue);
  };

  const existing = props.sortValue.find((sp) => sp.field === props.name);
  const value = existing ? existing.value : "";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: 200,
        padding: 5,
      }}
    >
      <Typography mr={1}>{props.name}</Typography>
      <ToggleButtonGroup
        size="small"
        exclusive
        onChange={handleChange}
        value={value}
      >
        <ToggleButton value="asc">ASC</ToggleButton>
        <ToggleButton value="desc">DESC</ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};

export default SortToggle;
